import api from './api';
import authHeader from './auth-header';

class InAppMessageService {
    getAudience(onlyActiveAttendance = false) {
        return api.get('/in-app-messages/audience', { 
            params: { onlyActiveAttendance },
            headers: authHeader() 
        });
    }

    sendInAppMessage(payload, employeeIds) {
        return api.post('/in-app-messages/send', {
            payload,
            employeeIds
        }, { headers: authHeader() });
    }

    generateContent(topic, language) {
        return api.post('/in-app-messages/generate', {
            topic,
            language
        }, { headers: authHeader() });
    }
}

const inAppMessageService = new InAppMessageService();
export default inAppMessageService;

